import { html, svg } from 'lit';

export const Triangle = html`
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Polygon 19"
      d="M12.6809 16.8585C12.2821 17.4176 11.4514 17.4176 11.0526 16.8585L0.754394 2.41961C0.282281 1.75767 0.755483 0.838941 1.56853 0.838941L22.165 0.838943C22.978 0.838943 23.4512 1.75767 22.9791 2.41961L12.6809 16.8585Z"
      fill="currentColor"
    />
  </svg>
`;

export const TemplateCard1 = {
  light: svg`<svg width="62" height="40" viewBox="0 0 62 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d_744_3554)">
  <g clip-path="url(#clip0_744_3554)">
  <rect x="4.76465" y="4.82324" width="52.7059" height="30.8021" rx="3" fill="white"/>
  <rect x="7.35547" y="7.66992" width="21.7372" height="11.3655" rx="1" fill="#DFF4E8"/>
  <rect x="32.832" y="7.6084" width="21.7372" height="11.3655" rx="1" fill="#DFF4F3"/>
  <rect x="7.42578" y="21.8467" width="21.7372" height="11.3655" rx="1" fill="#FFEACA"/>
  <rect x="32.8408" y="21.7988" width="21.7372" height="11.3655" rx="1" fill="#FFE1E1"/>
  <g filter="url(#filter1_d_744_3554)">
  <rect x="8.49219" y="9.00781" width="4.13581" height="3.08021" fill="#9DD194"/>
  <rect x="8.54219" y="9.05781" width="4.03581" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter2_d_744_3554)">
  <rect x="8.49219" y="14.0635" width="4.13581" height="3.08021" fill="#9DD194"/>
  <rect x="8.54219" y="14.1135" width="4.03581" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter3_d_744_3554)">
  <rect x="13.4521" y="9.00781" width="3.72042" height="3.08021" fill="#9DD194"/>
  <rect x="13.5021" y="9.05781" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter4_d_744_3554)">
  <rect x="37.6836" y="11.4336" width="3.72042" height="3.08021" fill="#84CFFF"/>
  <rect x="37.7336" y="11.4836" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter5_d_744_3554)">
  <rect x="43.2646" y="11.4336" width="3.72042" height="3.08021" fill="#84CFFF"/>
  <rect x="43.3146" y="11.4836" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter6_d_744_3554)">
  <rect x="48.8447" y="11.4336" width="3.72042" height="3.08021" fill="#84CFFF"/>
  <rect x="48.8947" y="11.4836" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter7_d_744_3554)">
  <rect x="34.2461" y="22.8467" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="34.2961" y="22.8967" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter8_d_744_3554)">
  <rect x="39.2061" y="22.8467" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="39.2561" y="22.8967" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter9_d_744_3554)">
  <rect x="44.167" y="22.8467" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="44.217" y="22.8967" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter10_d_744_3554)">
  <rect x="49.127" y="22.8467" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="49.177" y="22.8967" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter11_d_744_3554)">
  <rect x="49.127" y="26.543" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="49.177" y="26.593" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter12_d_744_3554)">
  <rect x="44.167" y="26.543" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="44.217" y="26.593" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter13_d_744_3554)">
  <rect x="39.2061" y="26.543" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="39.2561" y="26.593" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter14_d_744_3554)">
  <rect x="34.2461" y="26.543" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="34.2961" y="26.593" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter15_d_744_3554)">
  <rect x="18.4131" y="9.00781" width="3.72042" height="3.08021" fill="#9DD194"/>
  <rect x="18.4631" y="9.05781" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <line x1="7.8916" y1="20.7553" x2="54.2721" y2="20.7553" stroke="#A7A7A7" stroke-width="0.3"/>
  <line x1="30.9918" y1="8.72949" x2="30.9918" y2="32.2467" stroke="#A7A7A7" stroke-width="0.3"/>
  <g filter="url(#filter16_d_744_3554)">
  <rect x="8.62012" y="23.1807" width="3.72042" height="3.08021" fill="#FFC46B"/>
  <rect x="8.67012" y="23.2307" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter17_d_744_3554)">
  <rect x="13.7139" y="25.6592" width="3.72042" height="3.08021" fill="#FFC46B"/>
  <rect x="13.7639" y="25.7092" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter18_d_744_3554)">
  <rect x="18.7031" y="23.9033" width="3.72042" height="3.08021" fill="#FFC46B"/>
  <rect x="18.7531" y="23.9533" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter19_d_744_3554)">
  <rect x="20.5752" y="28.8613" width="3.72042" height="3.08021" fill="#FFC46B"/>
  <rect x="20.6252" y="28.9113" width="3.62042" height="2.98021" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  </g>
  <rect x="5.06465" y="5.12324" width="52.1059" height="30.2021" rx="2.7" stroke="#E3E2E4" stroke-width="0.6"/>
  </g>
  <defs>
  <filter id="filter0_d_744_3554" x="0.764648" y="0.823242" width="60.7061" height="38.8018" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="2"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter1_d_744_3554" x="-10.6457" y="-10.1301" width="42.4116" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter2_d_744_3554" x="-10.6457" y="-5.07445" width="42.4116" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter3_d_744_3554" x="-5.68578" y="-10.1301" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter4_d_744_3554" x="18.5457" y="-7.70434" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter5_d_744_3554" x="24.1267" y="-7.70434" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter6_d_744_3554" x="29.7068" y="-7.70434" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter7_d_744_3554" x="15.1082" y="3.70875" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter8_d_744_3554" x="20.0681" y="3.70875" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter9_d_744_3554" x="25.0291" y="3.70875" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter10_d_744_3554" x="29.989" y="3.70875" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter11_d_744_3554" x="29.989" y="7.40504" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter12_d_744_3554" x="25.0291" y="7.40504" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter13_d_744_3554" x="20.0681" y="7.40504" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter14_d_744_3554" x="15.1082" y="7.40504" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter15_d_744_3554" x="-0.724844" y="-10.1301" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter16_d_744_3554" x="-10.5178" y="4.04273" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter17_d_744_3554" x="-5.42406" y="6.52125" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter18_d_744_3554" x="-0.434805" y="4.76539" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <filter id="filter19_d_744_3554" x="1.43727" y="9.7234" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3554"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3554" result="shape"/>
  </filter>
  <clipPath id="clip0_744_3554">
  <rect x="4.76465" y="4.82324" width="52.7059" height="30.8021" rx="3" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  `,
  dark: svg`<svg width="62" height="40" viewBox="0 0 62 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d_744_3621)">
  <g clip-path="url(#clip0_744_3621)">
  <rect x="4.76465" y="4.82324" width="52.7059" height="30.8021" rx="3" fill="black"/>
  <rect x="7.35547" y="7.66992" width="21.7372" height="11.3655" rx="1" fill="#2C6C3F"/>
  <rect x="32.832" y="7.6084" width="21.7372" height="11.3655" rx="1" fill="#1A736E"/>
  <rect x="7.42578" y="21.8467" width="21.7372" height="11.3655" rx="1" fill="#B9812E"/>
  <rect x="32.8408" y="21.7988" width="21.7372" height="11.3655" rx="1" fill="#6F3232"/>
  <g filter="url(#filter1_d_744_3621)">
  <rect x="8.49219" y="9.00781" width="4.13581" height="3.08021" fill="#9DD194"/>
  <rect x="8.54219" y="9.05781" width="4.03581" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter2_d_744_3621)">
  <rect x="8.49219" y="14.0635" width="4.13581" height="3.08021" fill="#9DD194"/>
  <rect x="8.54219" y="14.1135" width="4.03581" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter3_d_744_3621)">
  <rect x="13.4521" y="9.00781" width="3.72042" height="3.08021" fill="#9DD194"/>
  <rect x="13.5021" y="9.05781" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter4_d_744_3621)">
  <rect x="37.6836" y="11.4336" width="3.72042" height="3.08021" fill="#84CFFF"/>
  <rect x="37.7336" y="11.4836" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter5_d_744_3621)">
  <rect x="43.2646" y="11.4336" width="3.72042" height="3.08021" fill="#84CFFF"/>
  <rect x="43.3146" y="11.4836" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter6_d_744_3621)">
  <rect x="48.8447" y="11.4336" width="3.72042" height="3.08021" fill="#84CFFF"/>
  <rect x="48.8947" y="11.4836" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter7_d_744_3621)">
  <rect x="34.2461" y="22.8467" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="34.2961" y="22.8967" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter8_d_744_3621)">
  <rect x="39.2061" y="22.8467" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="39.2561" y="22.8967" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter9_d_744_3621)">
  <rect x="44.167" y="22.8467" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="44.217" y="22.8967" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter10_d_744_3621)">
  <rect x="49.127" y="22.8467" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="49.177" y="22.8967" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter11_d_744_3621)">
  <rect x="49.127" y="26.543" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="49.177" y="26.593" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter12_d_744_3621)">
  <rect x="44.167" y="26.543" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="44.217" y="26.593" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter13_d_744_3621)">
  <rect x="39.2061" y="26.543" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="39.2561" y="26.593" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter14_d_744_3621)">
  <rect x="34.2461" y="26.543" width="3.72042" height="3.08021" fill="#F16F6F"/>
  <rect x="34.2961" y="26.593" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter15_d_744_3621)">
  <rect x="18.4131" y="9.00781" width="3.72042" height="3.08021" fill="#9DD194"/>
  <rect x="18.4631" y="9.05781" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <line x1="7.8916" y1="20.7553" x2="54.2721" y2="20.7553" stroke="#A7A7A7" stroke-width="0.3"/>
  <line x1="30.9918" y1="8.72949" x2="30.9918" y2="32.2467" stroke="#A7A7A7" stroke-width="0.3"/>
  <g filter="url(#filter16_d_744_3621)">
  <rect x="8.62012" y="23.1807" width="3.72042" height="3.08021" fill="#FFC46B"/>
  <rect x="8.67012" y="23.2307" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter17_d_744_3621)">
  <rect x="13.7139" y="25.6592" width="3.72042" height="3.08021" fill="#FFC46B"/>
  <rect x="13.7639" y="25.7092" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter18_d_744_3621)">
  <rect x="18.7031" y="23.9033" width="3.72042" height="3.08021" fill="#FFC46B"/>
  <rect x="18.7531" y="23.9533" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter19_d_744_3621)">
  <rect x="20.5752" y="28.8613" width="3.72042" height="3.08021" fill="#FFC46B"/>
  <rect x="20.6252" y="28.9113" width="3.62042" height="2.98021" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  </g>
  <rect x="5.26465" y="5.32324" width="51.7059" height="29.8021" rx="2.5" stroke="#727272"/>
  </g>
  <defs>
  <filter id="filter0_d_744_3621" x="0.764648" y="0.823242" width="60.7061" height="38.8018" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="2"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter1_d_744_3621" x="-10.6457" y="-10.1301" width="42.4116" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter2_d_744_3621" x="-10.6457" y="-5.07445" width="42.4116" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter3_d_744_3621" x="-5.68578" y="-10.1301" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter4_d_744_3621" x="18.5457" y="-7.70434" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter5_d_744_3621" x="24.1267" y="-7.70434" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter6_d_744_3621" x="29.7068" y="-7.70434" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter7_d_744_3621" x="15.1082" y="3.70875" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter8_d_744_3621" x="20.0681" y="3.70875" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter9_d_744_3621" x="25.0291" y="3.70875" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter10_d_744_3621" x="29.989" y="3.70875" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter11_d_744_3621" x="29.989" y="7.40504" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter12_d_744_3621" x="25.0291" y="7.40504" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter13_d_744_3621" x="20.0681" y="7.40504" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter14_d_744_3621" x="15.1082" y="7.40504" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter15_d_744_3621" x="-0.724844" y="-10.1301" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter16_d_744_3621" x="-10.5178" y="4.04273" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter17_d_744_3621" x="-5.42406" y="6.52125" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter18_d_744_3621" x="-0.434805" y="4.76539" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <filter id="filter19_d_744_3621" x="1.43727" y="9.7234" width="41.9966" height="41.3559" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3621"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3621" result="shape"/>
  </filter>
  <clipPath id="clip0_744_3621">
  <rect x="4.76465" y="4.82324" width="52.7059" height="30.8021" rx="3" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  `,
};
export const TemplateCard2 = {
  light: svg`<svg width="55" height="36" viewBox="0 0 55 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d_744_3580)">
  <rect width="46.1176" height="27.128" rx="3" transform="matrix(1 0 0 -1 4.5293 31.2461)" fill="white"/>
  <rect x="0.3" y="-0.3" width="45.5176" height="26.528" rx="2.7" transform="matrix(1 0 0 -1 4.5293 30.6461)" stroke="#E3E2E4" stroke-width="0.6"/>
  <line y1="-0.109324" x2="3.25536" y2="-0.109324" transform="matrix(1 0 0 -1 13.21 13.8838)" stroke="#6B6B6B" stroke-width="0.218649"/>
  <line y1="-0.109324" x2="3.25536" y2="-0.109324" transform="matrix(1 0 0 -1 13.21 13.8838)" stroke="#6B6B6B" stroke-width="0.218649"/>
  <path d="M22.4336 14.4268H24.1332V18.8259V20.9374L26.2315 20.9375" stroke="#6B6B6B" stroke-width="0.218649"/>
  <path d="M32.7422 20.9373H39.3551V24.1926V25.8203L41.4232 25.8203" stroke="#6B6B6B" stroke-width="0.218649"/>
  <path d="M20.2637 14.427H23.9576L23.9579 11.2328V9.54401L26.2318 9.54395" stroke="#6B6B6B" stroke-width="0.218649"/>
  <path d="M38.168 20.9377H39.6247V17.6824V16.0547L41.4233 16.0547" stroke="#6B6B6B" stroke-width="0.218649"/>
  <rect width="6.51073" height="3.79792" rx="0.728829" transform="matrix(1 0 0 -1 26.2314 11.7139)" fill="#9DD194"/>
  <rect x="0.0364415" y="-0.0364415" width="6.43784" height="3.72504" rx="0.692388" transform="matrix(1 0 0 -1 26.2314 11.641)" stroke="black" stroke-opacity="0.1" stroke-width="0.0728829"/>
  <rect width="7.05329" height="3.25536" rx="0.728829" transform="matrix(1 0 0 -1 6.15723 16.0547)" fill="#FFDE6B"/>
  <rect x="0.0364415" y="-0.0364415" width="6.9804" height="3.18248" rx="0.692388" transform="matrix(1 0 0 -1 6.15723 15.9818)" stroke="black" stroke-opacity="0.1" stroke-width="0.0728829"/>
  <rect width="3.37861" height="3.37861" transform="matrix(0.707107 0.707107 0.707107 -0.707107 34.2441 20.8691)" fill="#937EE7"/>
  <rect x="0.051536" width="3.30572" height="3.30572" transform="matrix(0.707107 0.707107 0.707107 -0.707107 34.2592 20.8327)" stroke="black" stroke-opacity="0.1" stroke-width="0.0728829"/>
  <rect width="3.37861" height="3.37861" transform="matrix(0.707107 0.707107 0.707107 -0.707107 16.1426 14.4902)" fill="#937EE7"/>
  <rect x="0.051536" width="3.30572" height="3.30572" transform="matrix(0.707107 0.707107 0.707107 -0.707107 16.1577 14.4538)" stroke="black" stroke-opacity="0.1" stroke-width="0.0728829"/>
  <rect width="6.51073" height="3.79792" rx="0.728829" transform="matrix(1 0 0 -1 26.2314 22.5654)" fill="#FFDE6B"/>
  <rect x="0.0364415" y="-0.0364415" width="6.43784" height="3.72504" rx="0.692388" transform="matrix(1 0 0 -1 26.2314 22.4925)" stroke="black" stroke-opacity="0.1" stroke-width="0.0728829"/>
  <rect width="7.05329" height="3.25536" rx="0.728829" transform="matrix(1 0 0 -1 41.4238 26.9053)" fill="#937EE7"/>
  <rect x="0.0364415" y="-0.0364415" width="6.9804" height="3.18248" rx="0.692388" transform="matrix(1 0 0 -1 41.4238 26.8324)" stroke="black" stroke-opacity="0.1" stroke-width="0.0728829"/>
  <rect width="7.05329" height="3.79792" rx="0.728829" transform="matrix(1 0 0 -1 41.4238 18.2246)" fill="#937EE7"/>
  <rect x="0.0364415" y="-0.0364415" width="6.9804" height="3.72504" rx="0.692388" transform="matrix(1 0 0 -1 41.4238 18.1517)" stroke="black" stroke-opacity="0.1" stroke-width="0.0728829"/>
  </g>
  <defs>
  <filter id="filter0_d_744_3580" x="0.529297" y="0.118164" width="54.1172" height="35.1279" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="2"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3580"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3580" result="shape"/>
  </filter>
  </defs>
  </svg>
  `,
  dark: svg`<svg width="55" height="36" viewBox="0 0 55 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d_744_3647)">
  <rect width="46.1176" height="27.128" rx="3" transform="matrix(1 0 0 -1 4.5293 31.2461)" fill="#1B1B1B"/>
  <rect x="0.5" y="-0.5" width="45.1176" height="26.128" rx="2.5" transform="matrix(1 0 0 -1 4.5293 30.2461)" stroke="#727272"/>
  <line y1="-0.109324" x2="3.25536" y2="-0.109324" transform="matrix(1 0 0 -1 13.21 13.8838)" stroke="#6B6B6B" stroke-width="0.218649"/>
  <line y1="-0.109324" x2="3.25536" y2="-0.109324" transform="matrix(1 0 0 -1 13.21 13.8838)" stroke="#6B6B6B" stroke-width="0.218649"/>
  <path d="M22.4336 14.4268H24.1332V18.8259V20.9374L26.2315 20.9375" stroke="#6B6B6B" stroke-width="0.218649"/>
  <path d="M32.7422 20.9373H39.3551V24.1926V25.8203L41.4232 25.8203" stroke="#6B6B6B" stroke-width="0.218649"/>
  <path d="M20.2637 14.427H23.9576L23.9579 11.2328V9.54401L26.2318 9.54395" stroke="#6B6B6B" stroke-width="0.218649"/>
  <path d="M38.168 20.9377H39.6247V17.6824V16.0547L41.4233 16.0547" stroke="#6B6B6B" stroke-width="0.218649"/>
  <rect width="6.51073" height="3.79792" rx="0.728829" transform="matrix(1 0 0 -1 26.2314 11.7139)" fill="#9DD194"/>
  <rect x="0.0364415" y="-0.0364415" width="6.43784" height="3.72504" rx="0.692388" transform="matrix(1 0 0 -1 26.2314 11.641)" stroke="white" stroke-opacity="0.1" stroke-width="0.0728829"/>
  <rect width="7.05329" height="3.25536" rx="0.728829" transform="matrix(1 0 0 -1 6.15723 16.0547)" fill="#FFD338"/>
  <rect x="0.0364415" y="-0.0364415" width="6.9804" height="3.18248" rx="0.692388" transform="matrix(1 0 0 -1 6.15723 15.9818)" stroke="white" stroke-opacity="0.1" stroke-width="0.0728829"/>
  <rect width="3.37861" height="3.37861" transform="matrix(0.707107 0.707107 0.707107 -0.707107 34.2441 20.8691)" fill="#937EE7"/>
  <rect x="0.051536" width="3.30572" height="3.30572" transform="matrix(0.707107 0.707107 0.707107 -0.707107 34.2592 20.8327)" stroke="white" stroke-opacity="0.1" stroke-width="0.0728829"/>
  <rect width="3.37861" height="3.37861" transform="matrix(0.707107 0.707107 0.707107 -0.707107 16.1426 14.4902)" fill="#937EE7"/>
  <rect x="0.051536" width="3.30572" height="3.30572" transform="matrix(0.707107 0.707107 0.707107 -0.707107 16.1577 14.4538)" stroke="white" stroke-opacity="0.1" stroke-width="0.0728829"/>
  <rect width="6.51073" height="3.79792" rx="0.728829" transform="matrix(1 0 0 -1 26.2314 22.5654)" fill="#FFD338"/>
  <rect x="0.0364415" y="-0.0364415" width="6.43784" height="3.72504" rx="0.692388" transform="matrix(1 0 0 -1 26.2314 22.4925)" stroke="white" stroke-opacity="0.1" stroke-width="0.0728829"/>
  <rect width="7.05329" height="3.25536" rx="0.728829" transform="matrix(1 0 0 -1 41.4238 26.9053)" fill="#937EE7"/>
  <rect x="0.0364415" y="-0.0364415" width="6.9804" height="3.18248" rx="0.692388" transform="matrix(1 0 0 -1 41.4238 26.8324)" stroke="white" stroke-opacity="0.1" stroke-width="0.0728829"/>
  <rect width="7.05329" height="3.79792" rx="0.728829" transform="matrix(1 0 0 -1 41.4238 18.2246)" fill="#937EE7"/>
  <rect x="0.0364415" y="-0.0364415" width="6.9804" height="3.72504" rx="0.692388" transform="matrix(1 0 0 -1 41.4238 18.1517)" stroke="white" stroke-opacity="0.1" stroke-width="0.0728829"/>
  </g>
  <defs>
  <filter id="filter0_d_744_3647" x="0.529297" y="0.118164" width="54.1172" height="35.1279" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="2"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3647"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3647" result="shape"/>
  </filter>
  </defs>
  </svg>
  `,
};
export const TemplateCard3 = {
  light: svg`<svg width="80" height="51" viewBox="0 0 80 51" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d_744_3594)">
  <g clip-path="url(#clip0_744_3594)">
  <rect x="4.29395" y="4" width="71.5294" height="42.0761" rx="4" fill="white"/>
  <rect x="7.66016" y="9.89062" width="5.89066" height="1.68304" rx="0.841522" fill="#FFEACA"/>
  <rect x="7.66016" y="13.2568" width="20.1965" height="33.6609" rx="1" fill="#FFEACA"/>
  <g filter="url(#filter1_d_744_3594)">
  <rect x="8.50195" y="15.7812" width="5.04914" height="4.20761" fill="#FFDE6B"/>
  <rect x="8.55195" y="15.8313" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter2_d_744_3594)">
  <rect x="8.50195" y="22.5137" width="5.04914" height="4.20761" fill="#FFDE6B"/>
  <rect x="8.55195" y="22.5637" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter3_d_744_3594)">
  <rect x="8.50195" y="28.4043" width="5.04914" height="4.20761" fill="#FFDE6B"/>
  <rect x="8.55195" y="28.4543" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter4_d_744_3594)">
  <rect x="15.2334" y="15.7812" width="5.04914" height="4.20761" fill="#FFDE6B"/>
  <rect x="15.2834" y="15.8313" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter5_d_744_3594)">
  <rect x="15.2334" y="22.5137" width="5.04914" height="4.20761" fill="#FFDE6B"/>
  <rect x="15.2834" y="22.5637" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter6_d_744_3594)">
  <rect x="15.2334" y="28.4043" width="5.04914" height="4.20761" fill="#9DD194"/>
  <rect x="15.2834" y="28.4543" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter7_d_744_3594)">
  <rect x="21.9658" y="15.7812" width="5.04914" height="4.20761" fill="#FFDE6B"/>
  <rect x="22.0158" y="15.8313" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter8_d_744_3594)">
  <rect x="21.9658" y="22.5137" width="5.04914" height="4.20761" fill="#FFDE6B"/>
  <rect x="22.0158" y="22.5637" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter9_d_744_3594)">
  <rect x="21.9658" y="28.4043" width="5.04914" height="4.20761" fill="#F16F6F"/>
  <rect x="22.0158" y="28.4543" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <rect x="30.3809" y="9.89062" width="5.89066" height="1.68304" rx="0.841522" fill="#E1EFFF"/>
  <rect x="30.3809" y="13.2568" width="20.1965" height="33.6609" rx="1" fill="#E1EFFF"/>
  <g filter="url(#filter10_d_744_3594)">
  <rect x="31.2227" y="15.7812" width="5.04914" height="4.20761" fill="#B8E3FF"/>
  <rect x="31.2727" y="15.8313" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter11_d_744_3594)">
  <rect x="31.2227" y="21.6719" width="5.04914" height="4.20761" fill="#B8E3FF"/>
  <rect x="31.2727" y="21.7219" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter12_d_744_3594)">
  <rect x="37.9551" y="15.7812" width="5.04914" height="4.20761" fill="#B8E3FF"/>
  <rect x="38.0051" y="15.8313" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter13_d_744_3594)">
  <rect x="37.9551" y="21.6719" width="5.04914" height="4.20761" fill="#FFC46B"/>
  <rect x="38.0051" y="21.7219" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter14_d_744_3594)">
  <rect x="44.6875" y="15.7812" width="5.04914" height="4.20761" fill="#B8E3FF"/>
  <rect x="44.7375" y="15.8313" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <rect x="53.1025" y="9.89062" width="5.89066" height="1.68304" rx="0.841522" fill="#DFF4E8"/>
  <rect x="53.1025" y="13.2568" width="20.1965" height="33.6609" rx="1" fill="#DFF4E8"/>
  <g filter="url(#filter15_d_744_3594)">
  <rect x="53.9434" y="15.7812" width="5.04914" height="4.20761" fill="#9DD194"/>
  <rect x="53.9934" y="15.8313" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter16_d_744_3594)">
  <rect x="53.9434" y="21.6719" width="5.04914" height="4.20761" fill="#9DD194"/>
  <rect x="53.9934" y="21.7219" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter17_d_744_3594)">
  <rect x="60.6758" y="15.7812" width="5.04914" height="4.20761" fill="#9DD194"/>
  <rect x="60.7258" y="15.8313" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter18_d_744_3594)">
  <rect x="60.6758" y="21.6719" width="5.04914" height="4.20761" fill="#FFC46B"/>
  <rect x="60.7258" y="21.7219" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter19_d_744_3594)">
  <rect x="67.4082" y="15.7812" width="5.04914" height="4.20761" fill="#9DD194"/>
  <rect x="67.4582" y="15.8313" width="4.94914" height="4.10761" stroke="black" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  </g>
  <rect x="4.59395" y="4.3" width="70.9294" height="41.4761" rx="3.7" stroke="#E3E2E4" stroke-width="0.6"/>
  </g>
  <defs>
  <filter id="filter0_d_744_3594" x="0.293945" y="0" width="79.5293" height="50.0762" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="2"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter1_d_744_3594" x="-10.636" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter2_d_744_3594" x="-10.636" y="3.37574" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter3_d_744_3594" x="-10.636" y="9.26637" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter4_d_744_3594" x="-3.90453" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter5_d_744_3594" x="-3.90453" y="3.37574" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter6_d_744_3594" x="-3.90453" y="9.26637" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter7_d_744_3594" x="2.82789" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter8_d_744_3594" x="2.82789" y="3.37574" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter9_d_744_3594" x="2.82789" y="9.26637" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter10_d_744_3594" x="12.0847" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter11_d_744_3594" x="12.0847" y="2.53395" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter12_d_744_3594" x="18.8171" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter13_d_744_3594" x="18.8171" y="2.53395" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter14_d_744_3594" x="25.5496" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter15_d_744_3594" x="34.8054" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter16_d_744_3594" x="34.8054" y="2.53395" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter17_d_744_3594" x="41.5379" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter18_d_744_3594" x="41.5379" y="2.53395" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <filter id="filter19_d_744_3594" x="48.2703" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3594"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3594" result="shape"/>
  </filter>
  <clipPath id="clip0_744_3594">
  <rect x="4.29395" y="4" width="71.5294" height="42.0761" rx="4" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  `,
  dark: svg`<svg width="80" height="51" viewBox="0 0 80 51" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d_744_3661)">
  <g clip-path="url(#clip0_744_3661)">
  <rect x="4.29395" y="4" width="71.5294" height="42.0761" rx="4" fill="#1A1A1A"/>
  <rect x="7.66016" y="9.89062" width="5.89066" height="1.68304" rx="0.841522" fill="#B9812E"/>
  <rect x="7.66016" y="13.2568" width="20.1965" height="30" rx="1" fill="#B9812E"/>
  <g filter="url(#filter1_d_744_3661)">
  <rect x="8.50195" y="15.7812" width="5.04914" height="4.20761" fill="#FFDE6B"/>
  <rect x="8.55195" y="15.8313" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter2_d_744_3661)">
  <rect x="8.50195" y="22.5137" width="5.04914" height="4.20761" fill="#FFDE6B"/>
  <rect x="8.55195" y="22.5637" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter3_d_744_3661)">
  <rect x="8.50195" y="28.4043" width="5.04914" height="4.20761" fill="#FFDE6B"/>
  <rect x="8.55195" y="28.4543" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter4_d_744_3661)">
  <rect x="15.2334" y="15.7812" width="5.04914" height="4.20761" fill="#FFDE6B"/>
  <rect x="15.2834" y="15.8313" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter5_d_744_3661)">
  <rect x="15.2334" y="22.5137" width="5.04914" height="4.20761" fill="#FFDE6B"/>
  <rect x="15.2834" y="22.5637" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter6_d_744_3661)">
  <rect x="15.2334" y="28.4043" width="5.04914" height="4.20761" fill="#9DD194"/>
  <rect x="15.2834" y="28.4543" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter7_d_744_3661)">
  <rect x="21.9658" y="15.7812" width="5.04914" height="4.20761" fill="#FFDE6B"/>
  <rect x="22.0158" y="15.8313" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter8_d_744_3661)">
  <rect x="21.9658" y="22.5137" width="5.04914" height="4.20761" fill="#FFDE6B"/>
  <rect x="22.0158" y="22.5637" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter9_d_744_3661)">
  <rect x="21.9658" y="28.4043" width="5.04914" height="4.20761" fill="#F16F6F"/>
  <rect x="22.0158" y="28.4543" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <rect x="30.3809" y="9.89062" width="5.89066" height="1.68304" rx="0.841522" fill="#084388"/>
  <rect x="30.3809" y="13.2568" width="20.1965" height="30" rx="1" fill="#084388"/>
  <g filter="url(#filter10_d_744_3661)">
  <rect x="31.2227" y="15.7812" width="5.04914" height="4.20761" fill="#B8E3FF"/>
  <rect x="31.2727" y="15.8313" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter11_d_744_3661)">
  <rect x="31.2227" y="21.6719" width="5.04914" height="4.20761" fill="#B8E3FF"/>
  <rect x="31.2727" y="21.7219" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter12_d_744_3661)">
  <rect x="37.9551" y="15.7812" width="5.04914" height="4.20761" fill="#B8E3FF"/>
  <rect x="38.0051" y="15.8313" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter13_d_744_3661)">
  <rect x="37.9551" y="21.6719" width="5.04914" height="4.20761" fill="#FFC46B"/>
  <rect x="38.0051" y="21.7219" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter14_d_744_3661)">
  <rect x="44.6875" y="15.7812" width="5.04914" height="4.20761" fill="#B8E3FF"/>
  <rect x="44.7375" y="15.8313" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <rect x="53.1025" y="9.89062" width="5.89066" height="1.68304" rx="0.841522" fill="#2C6C3F"/>
  <rect x="53.1025" y="13.2568" width="18" height="30" rx="1" fill="#2C6C3F"/>
  <g filter="url(#filter15_d_744_3661)">
  <rect x="53.9434" y="15.7812" width="5.04914" height="4.20761" fill="#9DD194"/>
  <rect x="53.9934" y="15.8313" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter16_d_744_3661)">
  <rect x="53.9434" y="21.6719" width="5.04914" height="4.20761" fill="#9DD194"/>
  <rect x="53.9934" y="21.7219" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter17_d_744_3661)">
  <rect x="60.6758" y="15.7812" width="5.04914" height="4.20761" fill="#9DD194"/>
  <rect x="60.7258" y="15.8313" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  <g filter="url(#filter18_d_744_3661)">
  <rect x="60.6758" y="21.6719" width="5.04914" height="4.20761" fill="#FFC46B"/>
  <rect x="60.7258" y="21.7219" width="4.94914" height="4.10761" stroke="white" stroke-opacity="0.1" stroke-width="0.1"/>
  </g>
  </g>
  <rect x="4.79395" y="4.5" width="70.5294" height="41.0761" rx="3.5" stroke="#727272"/>
  </g>
  <defs>
  <filter id="filter0_d_744_3661" x="0.293945" y="0" width="79.5293" height="50.0762" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="2"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.44 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter1_d_744_3661" x="-10.636" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter2_d_744_3661" x="-10.636" y="3.37574" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter3_d_744_3661" x="-10.636" y="9.26637" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter4_d_744_3661" x="-3.90453" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter5_d_744_3661" x="-3.90453" y="3.37574" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter6_d_744_3661" x="-3.90453" y="9.26637" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter7_d_744_3661" x="2.82789" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter8_d_744_3661" x="2.82789" y="3.37574" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter9_d_744_3661" x="2.82789" y="9.26637" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter10_d_744_3661" x="12.0847" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter11_d_744_3661" x="12.0847" y="2.53395" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter12_d_744_3661" x="18.8171" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter13_d_744_3661" x="18.8171" y="2.53395" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter14_d_744_3661" x="25.5496" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter15_d_744_3661" x="34.8054" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter16_d_744_3661" x="34.8054" y="2.53395" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter17_d_744_3661" x="41.5379" y="-3.35668" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <filter id="filter18_d_744_3661" x="41.5379" y="2.53395" width="43.3247" height="42.4839" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="9.56896"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.18 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_744_3661"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_744_3661" result="shape"/>
  </filter>
  <clipPath id="clip0_744_3661">
  <rect x="4.29395" y="4" width="71.5294" height="42.0761" rx="4" fill="white"/>
  </clipPath>
  </defs>
  </svg>
  `,
};

export const defaultPreview = html`
  <svg
    width="85"
    height="50"
    viewBox="0 0 85 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="85" height="50" fill="white" />
    <line
      x1="16"
      y1="31.8907"
      x2="22"
      y2="31.8907"
      stroke="#6B6B6B"
      stroke-width="0.218649"
    />
    <line
      x1="16"
      y1="31.8907"
      x2="22"
      y2="31.8907"
      stroke="#6B6B6B"
      stroke-width="0.218649"
    />
    <path
      d="M33 31H36.1325V22.8918V19.0001L40 19"
      stroke="#6B6B6B"
      stroke-width="0.218649"
    />
    <path
      d="M52 19H64.1883V13V10L68 10.0001"
      stroke="#6B6B6B"
      stroke-width="0.218649"
    />
    <path
      d="M29 31H35.8083L35.8089 36.8873V39.9999L40 40"
      stroke="#6B6B6B"
      stroke-width="0.218649"
    />
    <path
      d="M62 19H64.685V24.9999V27.9999L68 28"
      stroke="#6B6B6B"
      stroke-width="0.218649"
    />
    <rect x="40" y="36" width="12" height="7" rx="0.728829" fill="#9DD194" />
    <rect
      x="40.0364"
      y="36.0364"
      width="11.9271"
      height="6.92712"
      rx="0.692388"
      stroke="black"
      stroke-opacity="0.1"
      stroke-width="0.0728829"
    />
    <rect x="3" y="28" width="13" height="6" rx="0.728829" fill="#FFDE6B" />
    <rect
      x="3.03644"
      y="28.0364"
      width="12.9271"
      height="5.92712"
      rx="0.692388"
      stroke="black"
      stroke-opacity="0.1"
      stroke-width="0.0728829"
    />
    <rect
      x="54.7686"
      y="19.1265"
      width="6.22715"
      height="6.22715"
      transform="rotate(-45 54.7686 19.1265)"
      fill="#937EE7"
    />
    <rect
      x="54.8201"
      y="19.1265"
      width="6.15427"
      height="6.15427"
      transform="rotate(-45 54.8201 19.1265)"
      stroke="black"
      stroke-opacity="0.1"
      stroke-width="0.0728829"
    />
    <rect
      x="21.4038"
      y="30.8835"
      width="6.22715"
      height="6.22715"
      transform="rotate(-45 21.4038 30.8835)"
      fill="#937EE7"
    />
    <rect
      x="21.4553"
      y="30.8835"
      width="6.15427"
      height="6.15427"
      transform="rotate(-45 21.4553 30.8835)"
      stroke="black"
      stroke-opacity="0.1"
      stroke-width="0.0728829"
    />
    <rect x="40" y="16" width="12" height="7" rx="0.728829" fill="#FFDE6B" />
    <rect
      x="40.0364"
      y="16.0364"
      width="11.9271"
      height="6.92712"
      rx="0.692388"
      stroke="black"
      stroke-opacity="0.1"
      stroke-width="0.0728829"
    />
    <rect x="68" y="8" width="13" height="6" rx="0.728829" fill="#937EE7" />
    <rect
      x="68.0364"
      y="8.03644"
      width="12.9271"
      height="5.92712"
      rx="0.692388"
      stroke="black"
      stroke-opacity="0.1"
      stroke-width="0.0728829"
    />
    <rect x="68" y="24" width="13" height="7" rx="0.728829" fill="#937EE7" />
    <rect
      x="68.0364"
      y="24.0364"
      width="12.9271"
      height="6.92712"
      rx="0.692388"
      stroke="black"
      stroke-opacity="0.1"
      stroke-width="0.0728829"
    />
  </svg>
`;
